import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Divider from "@material-ui/core/Divider";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import IconButton from "@material-ui/core/IconButton";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import CancelIcon from "@material-ui/icons/Cancel";
import CloseIcon from "@material-ui/icons/Close";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { UserContext } from "../contexts/UserContext";
import WagersInfo from "./WagersInfo";

export default function GameModify(props) {
  const user = useContext(UserContext);
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    appBar: {
      position: "relative",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },
    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "75%",
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));
  const classes = useStyles();

  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(true);
  const [valuesLine, setValuesLine] = useState();
  const [lineValue, setLineValue] = useState();
  const [actionTypeChanged, setActionTypeChanged] = useState(0);
  const [playerTypeChanged, setPlayerTypeChanged] = useState(2);
  const [lineChanged, setLineChanged] = useState(2);
  const [straightBetChanged, setStraightBetChanged] = useState(true);
  const [parlaysChanged, setParlaysChanged] = useState(false);
  const [teasersChanged, setTeasersChanged] = useState(false);
  const [othersBetChanged, setOthersBetChanged] = useState(false);
  const [isTrue, setIsTrue] = useState(false);
  const [playValue, setPlayValue] = useState(props.Play);
  const [wagersValues, setWagersValues] = useState();
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );

  const handleActionTypeChanged = (event) => {
    setActionTypeChanged(event.target.value);
    VisitorValues();
  };
  const handlePlayerTypeChanged = (event) => {
    setPlayerTypeChanged(event.target.value);
    VisitorValues();
  };
  const handleLineChanged = (event) => {
    setLineChanged(event.target.value);
    VisitorValues();
  };

  const handleStraightBetChanged = (straightBet) => {
    setStraightBetChanged(straightBet);
    VisitorValues();
  };
  const handleParlaysChanged = (parlayBet) => {
    setParlaysChanged(parlayBet);
    VisitorValues();
  };
  const handleTeasersChanged = (teaserBet) => {
    setTeasersChanged(teaserBet);
    VisitorValues();
  };
  const handleOthersBetsChanged = (otherBet) => {
    setOthersBetChanged(otherBet);
    VisitorValues();
  };

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
    setOpen(false);
  };

  const VisitorValues = () => {
    console.log("IdLineType ======>", props.IdLinetype);
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Game/WagersOnGame_GetLines",
      /*  REPLACE WITH SELECT DATA */
      data: {
        //IdLineType: props.IdLinetype,
        IdLineType: -1,
        IdGame: props.IdGame,
        IdSport: props.IdSport,
        Play: props.Play,
        ActionType: actionTypeChanged,
        PlayerType: playerTypeChanged,
        Line: lineChanged,
        ShowStraightBet: straightBetChanged,
        ShowParlay: parlaysChanged,
        ShowTeaser: teasersChanged,
        ShowOthers: othersBetChanged,
        NHLAmerican: 0,
        userId: userInfo.userId,
      },
    })
      .then((response) => response.data)
      .then((data) => {
        setValuesLine(data);
        console.log("CHARTING VISITOR VALUES========>", data);
        console.log("props========>", props);
      })
      .then(setLoading(false));
  };

  const GetWagersValues = (pointsValue) => {
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Game/WagersOnGameGetWagers",
      /*  REPLACE WITH SELECT DATA */
      data: {
        //IdLineType: props.IdLinetype,
        IdLineType: -1,
        IdGame: props.IdGame,
        IdSport: props.IdSport,
        Play: playValue,
        Points: pointsValue,
        PlayerType: 2,
        Line: 2,
        ShowStraightBet: 1,
        ShowParlay: 0,
        ShowTeaser: 0,
        ShowOthers: 0,
        NHLAmerican: 0,
        userId: userInfo.userId,
      },
    })
      .then((response) => response.data)
      .then((data) => {
        setWagersValues(data.data);
      })
      .then(setLoading(false));
  };

  useEffect(() => {
    VisitorValues();
  }, []);

  useEffect(() => {
    GetWagersValues(props.Points);
  }, []);

  return (
    <React.Fragment>
      <Dialog style={{ maxWidth: "75%" }} open={open} onClose={handleClose}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Action vs Line
            </Typography>
          </Toolbar>
        </AppBar>
        {loading ? (
          <CircularProgress style={{ margin: "0 auto" }} />
        ) : (
          <React.Fragment>
            <br />
            <form className={classes.center}>
              <FormGroup row>
                <h5>Action</h5>
              </FormGroup>
              <FormGroup row>
                <RadioGroup row>
                  <FormControlLabel
                    control={
                      <Radio
                        checked={actionTypeChanged == "0"}
                        onChange={handleActionTypeChanged}
                        value="0"
                        label="None"
                        name="radio-button-time"
                        inputProps={{ "aria-label": "None" }}
                      />
                    }
                    label="Default"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    control={
                      <Radio
                        checked={actionTypeChanged == "1"}
                        onChange={handleActionTypeChanged}
                        value="1"
                        label="Home"
                        name="radio-button-time"
                        inputProps={{ "aria-label": "Home" }}
                      />
                    }
                    label="Risk"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    control={
                      <Radio
                        checked={actionTypeChanged == "2"}
                        onChange={handleActionTypeChanged}
                        value="2"
                        label="Visitor"
                        name="radio-button-time"
                        inputProps={{ "aria-label": "Visitor" }}
                      />
                    }
                    label="Win"
                    labelPlacement="end"
                  />
                </RadioGroup>
              </FormGroup>
              <Divider />
              <FormGroup row>
                <h5>Wager Type</h5>
              </FormGroup>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={straightBetChanged}
                      onChange={(ev) =>
                        handleStraightBetChanged(ev.currentTarget.checked)
                      }
                      color="primary"
                    />
                  }
                  label="StraightBet"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={parlaysChanged}
                      onChange={(ev) =>
                        handleParlaysChanged(ev.currentTarget.checked)
                      }
                      color="primary"
                    />
                  }
                  label="Parlays"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={teasersChanged}
                      onChange={(ev) =>
                        handleTeasersChanged(ev.currentTarget.checked)
                      }
                      color="primary"
                    />
                  }
                  label="Teasers"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={othersBetChanged}
                      onChange={(ev) =>
                        handleOthersBetsChanged(ev.currentTarget.checked)
                      }
                      color="primary"
                    />
                  }
                  label="Others"
                />
              </FormGroup>
              <Divider />
              <FormGroup row>
                <h5>Player Type</h5>
              </FormGroup>
              <FormGroup row>
                <RadioGroup row>
                  <FormControlLabel
                    control={
                      <Radio
                        checked={playerTypeChanged == "0"}
                        onChange={handlePlayerTypeChanged}
                        value="0"
                        label="None"
                        name="radio-button-time"
                        inputProps={{ "aria-label": "None" }}
                      />
                    }
                    label="Single Player"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    control={
                      <Radio
                        checked={playerTypeChanged == "1"}
                        onChange={handlePlayerTypeChanged}
                        value="1"
                        label="Home"
                        name="radio-button-time"
                        inputProps={{ "aria-label": "Home" }}
                      />
                    }
                    label="Master Player"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    control={
                      <Radio
                        checked={playerTypeChanged == "2"}
                        onChange={handlePlayerTypeChanged}
                        value="2"
                        label="Visitor"
                        name="radio-button-time"
                        inputProps={{ "aria-label": "Visitor" }}
                      />
                    }
                    label="Both"
                    labelPlacement="end"
                  />
                </RadioGroup>
              </FormGroup>
              <Divider />
              <FormGroup row>
                <h5>Line</h5>
              </FormGroup>
              <FormGroup row>
                <RadioGroup row>
                  <FormControlLabel
                    control={
                      <Radio
                        checked={lineChanged == "0"}
                        onChange={handleLineChanged}
                        value="0"
                        label="None"
                        name="radio-button-time"
                        inputProps={{ "aria-label": "None" }}
                      />
                    }
                    label="Normal"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    control={
                      <Radio
                        checked={lineChanged == "1"}
                        onChange={handleLineChanged}
                        value="1"
                        label="Home"
                        name="radio-button-time"
                        inputProps={{ "aria-label": "Home" }}
                      />
                    }
                    label="From Agent"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    control={
                      <Radio
                        checked={lineChanged == "2"}
                        onChange={handleLineChanged}
                        value="2"
                        label="Visitor"
                        name="radio-button-time"
                        inputProps={{ "aria-label": "Visitor" }}
                      />
                    }
                    label="Both"
                    labelPlacement="end"
                  />
                </RadioGroup>
              </FormGroup>
              <Divider />
              <FormGroup row>
                <FormControl
                  className={`${classes.formControl} w-full`}
                  size="small"
                  variant="outlined"
                >
                  <Table>
                    <TableHead className={classes.tableHead}>
                      <TableRow>
                        <TableCell className={classes.headerCell}>
                          <strong>{props.VisitorTeam}</strong>
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                          <strong>Amount</strong>
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                          <strong>{props.HomeTeam}</strong>
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                          <strong>Amount</strong>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {valuesLine &&
                        valuesLine.map((row) => (
                          <TableRow
                            key={`${row.Line}-${row.Side}`}
                            className={classes.tableRow}
                          >
                            <TableCell
                              className={classes.headerCell}
                              align="right"
                            >
                              {console.log("row======>", row)}
                              {row["Side"] === "V" ? (
                                <Button
                                  onClick={() => {
                                    GetWagersValues(row["Line"], props.Play);
                                    setIsTrue(true);
                                  }}
                                >
                                  <NumberFormat
                                    value={row["Line"]}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                  />
                                </Button>
                              ) : (
                                " "
                              )}
                            </TableCell>
                            <TableCell align="right">
                              {row["Side"] === "V" ? row["RV"] : ""}
                            </TableCell>
                            <TableCell
                              className={classes.headerCell}
                              align="right"
                            >
                              {row["Side"] === "H" ? (
                                <Button
                                  onClick={() => {
                                    GetWagersValues(
                                      row["Line"],
                                      props.Play + 1
                                    );
                                    setIsTrue(true);
                                  }}
                                >
                                  {row["Line"]}
                                </Button>
                              ) : (
                                " "
                              )}
                            </TableCell>
                            <TableCell align="right">
                              {row["Side"] === "H" ? row["RV"] : ""}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </FormControl>
              </FormGroup>
              <FormGroup>
                <FormControl
                  className={`${classes.formControl} w-full`}
                  size="small"
                  variant="outlined"
                >
                  {isTrue ? (
                    <WagersInfo
                      WagersValues={wagersValues}
                      GetWagersValues={GetWagersValues}
                    />
                  ) : (
                    ""
                  )}
                </FormControl>
              </FormGroup>
            </form>
          </React.Fragment>
        )}
        <DialogActions>
          <Button
            color="inherit"
            startIcon={<CancelIcon />}
            onClick={handleClose}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
